import React, { useState } from 'react';
import ItemCard from '../ItemCard/ItemCard';
import Loading from '../Loading/Loading';
import Error from '../Error/Error';
import { useCategories, useFilteredItems } from '../../hooks/useApi';
import './ItemsSection.css';

const ItemsSection: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('All');
  
  const { data: categories, loading: categoriesLoading, error: categoriesError } = useCategories();
  const { items: filteredItems, loading: itemsLoading, error: itemsError } = useFilteredItems(selectedCategory);

  const categoryOptions = ['All', ...(categories?.map(cat => cat.name) || [])];

  // Show loading state
  if (categoriesLoading || itemsLoading) {
    return (
      <section id="items" className="items-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">המוצרים שלנו</h2>

          </div>
          
          {/* Loading skeleton for categories */}
          <div className="category-filter">
            <div className="skeleton-line short" style={{ height: '40px', margin: '0.5rem' }}></div>
            <div className="skeleton-line short" style={{ height: '40px', margin: '0.5rem' }}></div>
            <div className="skeleton-line short" style={{ height: '40px', margin: '0.5rem' }}></div>
          </div>

          {/* Loading skeleton for items */}
          <div className="items-grid">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="skeleton-card">
                <div className="skeleton-image"></div>
                <div className="skeleton-content">
                  <div className="skeleton-line long"></div>
                  <div className="skeleton-line medium"></div>
                  <div className="skeleton-line short"></div>
                  <div className="skeleton-line medium"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  // Show error state
  if (categoriesError || itemsError) {
    return (
      <section id="items" className="items-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">המוצרים שלנו</h2>

          </div>
          
          <Error 
            message={categoriesError || itemsError || "אירעה שגיאה בטעינת הנתונים"}
            onRetry={() => window.location.reload()}
          />
        </div>
      </section>
    );
  }

  return (
    <section id="items" className="items-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">המוצרים שלנו</h2>
        </div>

        <div className="category-filter">
          {categoryOptions.map((category) => (
            <button
              key={category}
              className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="items-grid">
          {filteredItems.map((item) => (
            <ItemCard key={item.id} item={item} />
          ))}
        </div>

        {filteredItems.length === 0 && !itemsLoading && (
          <div className="no-items">
            <p>לא נמצאו פריטים בקטגוריה זו.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default ItemsSection;
